<template>
  <div class="chinese-push" v-loading="loading">
    <web-header language="cn" ref="webHeaderRef"></web-header>
    <div class="chinese-push-wrap">
      <div class="chinese-push-wrap-header">
        <div class="chinese-push-wrap-header-title">
          邮件推送
        </div>
      </div>
      <div class="chinese-push-wrap-tip">
        <p>订阅邮件推送，可及时获取CF40研究报告及活动信息。</p>
        <p>请输入您的电子邮件地址，选择您想订阅或者退订的研究产品，然后在底部提交。</p>
      </div>
      <div class="chinese-push-wrap-email">
        <div class="chinese-push-wrap-email-title">邮箱地址</div>
        <div class="chinese-push-wrap-email-input">
          <el-input v-model.trim="subForm.email" size="medium" placeholder="请输入您的邮箱地址" clearable></el-input>
        </div>
      </div>
      <div class="chinese-push-wrap-content" v-if="subForm.subscribe_type.indexOf(1) >= 0">
        <div class="chinese-push-wrap-content-title">订阅内容</div>
        <div class="chinese-push-wrap-content-list">
          <div class="chinese-push-wrap-content-list-group">
            <div class="chinese-push-wrap-content-list-group-title">报告类</div>
            <div class="chinese-push-wrap-content-list-group-listing">
              <div class="chinese-push-wrap-content-list-group-listing-cell" v-for="(item, index) in cnReportClass" :key="index">
                <div class="check-box" @click="productClassChange(item.id)" :data-text="item.description">
                  <div :class="{ 'square': true, 'active': subForm.subscribe_product_class_ids.indexOf(item.id) >= 0 }">
                    <i class="iconfont icon-tick"></i>
                  </div>
                  <div class="square-title">{{ item.class_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="chinese-push-wrap-content-list-group" v-if="cnActivityClass && cnActivityClass.length > 0">
            <div class="chinese-push-wrap-content-list-group-title">活动类</div>
            <div class="chinese-push-wrap-content-list-group-listing">
              <div class="chinese-push-wrap-content-list-group-listing-cell" v-for="(item, index) in cnActivityClass" :key="index">
                <div class="check-box" @click="activityClassChange(item.id)">
                  <div :class="{ 'square': true, 'active': subForm.subscribe_activity_class_ids.indexOf(item.id) >= 0 }">
                    <i class="iconfont icon-tick"></i>
                  </div>
                  <div class="square-title">{{ item.class_name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="english-push-wrap-content" v-if="subForm.subscribe_type.indexOf(2) >= 0">
        <div class="english-push-wrap-content-title">RESEARCH SERVICE</div>
        <div class="english-push-wrap-content-list">
          <div class="english-push-wrap-content-list-group">
            <div class="english-push-wrap-content-list-group-title">NEWSLETTER</div>
            <div class="english-push-wrap-content-list-group-listing">
              <div class="english-push-wrap-content-list-group-listing-cell" v-for="(item, index) in enReportClass" :key="index">
                <div class="check-box" @click="productClassChange(item.id)" :data-text="item.description">
                  <div :class="{ 'square': true, 'active': subForm.subscribe_product_class_ids.indexOf(item.id) >= 0 }">
                    <i class="iconfont icon-tick"></i>
                  </div>
                  <div class="square-title">{{ item.class_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="english-push-wrap-content-list-group" v-if="enActivityClass && enActivityClass.length > 0">
            <div class="english-push-wrap-content-list-group-title">EVENT</div>
            <div class="english-push-wrap-content-list-group-listing">
              <div class="english-push-wrap-content-list-group-listing-cell" v-for="(item, index) in enActivityClass" :key="index">
                <div class="check-box" @click="activityClassChange(item.id)">
                  <div :class="{ 'square': true, 'active': subForm.subscribe_activity_class_ids.indexOf(item.id) >= 0 }">
                    <i class="iconfont icon-tick"></i>
                  </div>
                  <div class="square-title">{{ item.class_name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chinese-push-wrap-language">
        <div class="chinese-push-wrap-language-title">语言</div>
        <div class="chinese-push-wrap-language-list">
          <div class="check-box" @click="subscribeTypeChange(1)">
            <div :class="{ 'square': true, 'active': subForm.subscribe_type.indexOf(1) >= 0 }">
              <i class="iconfont icon-tick"></i>
            </div>
            <div class="square-title">中文</div>
          </div>
          <div class="check-box" @click="subscribeTypeChange(2)">
            <div :class="{ 'square': true, 'active': subForm.subscribe_type.indexOf(2) >= 0 }">
              <i class="iconfont icon-tick"></i>
            </div>
            <div class="square-title">English</div>
          </div>
        </div>
      </div>
      <div class="chinese-push-wrap-opera">
        <el-button type="danger" size="medium" :loading="subLoading" @click="saveSubscribe">提交</el-button>
        <div class="chinese-push-wrap-opera-tip">
          <span>点击“提交”即确认接受本网站的</span>
          <span class="link" @click="openProtocol('','PRIVACY_CLAUSE')">隐私政策</span>。
        </div>
      </div>
    </div>
    <web-footer language="cn"></web-footer>
    <el-backtop></el-backtop>
    <service-agreement ref="serviceAgreementRef"></service-agreement>
  </div>
</template>

<script>
import WebHeader from "@/components/webHeader";
import WebFooter from "@/components/webFooter";
import ServiceAgreement from "@/components/serviceAgreement";
import { takeMailSubscriptionDraft } from '@/utils/mailSubscriptionDraft';
import { initConfig, classifyList, unsubscribe, emailSubscribe, activityClassList } from "@/api";
export default {
  name: "ChinesePush",
  components: {
    WebHeader,
    WebFooter,
    ServiceAgreement
  },
  data() {
    return {
      loading: false,
      subLoading: false,
      subForm: {
        email: "",
        subscribe_type: [1],
        subscribe_product_class_ids: [],
        subscribe_activity_class_ids: []
      },
      cnReportClass: [],
      enReportClass: [],
      cnActivityClass: [],
      enActivityClass: [],
      memberInfo: {}
    }
  },
  async created() {
    if (this.$route.query.type && this.$route.query.type == 'privacy') {
      let _This = this;
      setTimeout(() => {
        _This.openProtocol('','PRIVACY_CLAUSE');
      }, 500);
    }
    if (this.$route.query.mailpush) {
      await this.cancelMailSubscribe(this.$route.query.mailpush);
    }
    const draftEmail = takeMailSubscriptionDraft('cn');
    try {
      await this.getClassifyList();
      await this.getActivityClassList();
    } catch (error) { /* 请求层显示错误，仍保留入口带入的邮箱以便重试。 */ }
    finally {
      if (draftEmail) this.subForm.email = draftEmail;
      this.loading = false;
    }
  },
  methods: {
    resetForm() {
      this.subForm = {
        email: "",
        subscribe_type: [1],
        subscribe_product_class_ids: [],
        subscribe_activity_class_ids: []
      }
    },
    async openProtocol(name, key) {
      let res = await initConfig();
      if (res && res.code == 200) {
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            let item = res.data[i];
            if (item.config_key == key) {
              this.$refs.serviceAgreementRef.open(name, item.config_value);
              break;
            }
          }
        }
      }
    },
    async getClassifyList() {
      this.loading = true;
      let param = {
        pageSize: 50,
        currentPage: 1,
        orderBy: "sort",
        sortedBy: "desc",
        search: "is_show:true|can_subscribe:true|type:1",
        searchFields: "is_show:=|can_subscribe:=|type:=",
      };
      this.resetForm();
      let res = await classifyList(param);
      if (res && res.code == 200) {
        this.classifyHandle(res.data.list);
      }
      // this.loading = false;
    },
    classifyHandle(rows) {
      let enTemp = [];
      let cnTemp = [];
      if (rows && rows.length > 0) {
        for (let i = 0; i < rows.length; i++) {
          if (/^[a-zA-Z0-9 ,.'"\-\s]+$/.test(rows[i].class_name)) {
            enTemp.push(rows[i]);
          } else {
            cnTemp.push(rows[i]);
          }
        }
      }
      this.enReportClass = enTemp;
      this.cnReportClass = cnTemp;
      if (cnTemp && cnTemp.length > 0) {
        this.subForm.subscribe_product_class_ids = cnTemp.map(item => item.id);
      }
    },
    async getActivityClassList() {
      let param = {
        pageSize: 50,
        currentPage: 1,
        orderBy: "sort",
        sortedBy: "desc",
        search: "can_subscribe:true",
        searchFields: "can_subscribe:=",
      };
      let res = await activityClassList(param);
      if (res && res.code == 200) {
        this.activityClassHandle(res.data.list);
      }
      this.loading = false;
    },
    activityClassHandle(rows) {
      let enTemp = [];
      let cnTemp = [];
      if (rows && rows.length > 0) {
        let cnObj = {id: 99999, class_name: '其他', ids:[]};
        let enObj = {id: 88888, class_name: 'Other', ids:[]};
        for (let i = 0; i < rows.length; i++) {
          if (/^[a-zA-Z0-9 ,.'"\-\s]+$/.test(rows[i].class_name)) {
            if (rows[i].is_other) {
              enObj.ids.push(rows[i].id);
            } else {
              enTemp.push(rows[i]);
            }
          } else {
            if (rows[i].is_other) {
              cnObj.ids.push(rows[i].id);
            } else {
              cnTemp.push(rows[i]);
            }
          }
        }
        if (enObj.ids.length > 0) {
          enTemp.push(enObj);
        }
        if (cnObj.ids.length > 0) {
          cnTemp.push(cnObj);
        }
      }
      this.enActivityClass = enTemp;
      this.cnActivityClass = cnTemp;
      if (cnTemp && cnTemp.length > 0) {
        this.subForm.subscribe_activity_class_ids = cnTemp.map(item => item.id);
      }
    },

    subscribeTypeChange(e) {
      const index = this.subForm.subscribe_type.indexOf(e);
      if (index >= 0) {
        if (this.subForm.subscribe_type.length == 1) {
          this.$message.warning("至少选择一种语言");
        } else {
          this.subForm.subscribe_type.splice(index, 1);
        }
      } else {
        this.subForm.subscribe_type.push(e);
      }
      if (this.subForm.subscribe_type.length == 2) {
        let cnTemp = this.cnReportClass.map(item => item.id);
        let enTemp = this.enReportClass.map(item => item.id);
        this.subForm.subscribe_product_class_ids = cnTemp.concat(enTemp);
      } else if (this.subForm.subscribe_type.length == 1) {
        if (this.subForm.subscribe_type[0] == 1) {
          this.subForm.subscribe_product_class_ids = this.cnReportClass.map(item => item.id);
        } else {
          this.subForm.subscribe_product_class_ids = this.enReportClass.map(item => item.id);
        }
      }
    },
    productClassChange(e) {
      const index = this.subForm.subscribe_product_class_ids.indexOf(e);
      if (index >= 0) {
        let cnHas = this.subForm.subscribe_product_class_ids.filter(item => this.cnReportClass.map(test => test.id).includes(item));
        let enHas = this.subForm.subscribe_product_class_ids.filter(item => this.enReportClass.map(test => test.id).includes(item));
        if (this.subForm.subscribe_type.length == 2) {
          if (cnHas.indexOf(e)>=0 && cnHas.length == 1) {
            this.$message.warning("至少选择一种中文报告类别");
          } else if (enHas.indexOf(e)>=0 && enHas.length == 1) {
            this.$message.warning("至少选择一种英文报告类别");
          } else {
            this.subForm.subscribe_product_class_ids.splice(index, 1);
          }
        } else if (this.subForm.subscribe_type.length == 1) {
          if (this.subForm.subscribe_type[0] == 1) {
            if (cnHas.length > 1) {
              this.subForm.subscribe_product_class_ids.splice(index, 1);
            } else {
              this.$message.warning("至少选择一种中文报告类别");
            }
          } else {
            if (enHas.length > 1) {
              this.subForm.subscribe_product_class_ids.splice(index, 1);
            } else {
              this.$message.warning("至少选择一种英文报告类别");
            }
          }
        }
      } else {
        this.subForm.subscribe_product_class_ids.push(e);
      }
    },
    activityClassChange(e) {
      const index = this.subForm.subscribe_activity_class_ids.indexOf(e);
      if (index >= 0) {
        this.subForm.subscribe_activity_class_ids.splice(index, 1);
      } else {
        this.subForm.subscribe_activity_class_ids.push(e);
      }
    },

    validateForm() {
      let bool = true;
      let sendForm = {
        email: this.subForm.email,
        subscribe_type: this.subForm.subscribe_type.join(),
        subscribe_product_class_ids: this.subForm.subscribe_product_class_ids.join(),
        subscribe_activity_class_ids: ""
      };
      if (!this.subForm.email) {
        this.$message.error("请填写邮箱");
        bool = false;
      } else if (this.subForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.subForm.email)) {
        this.$message.error("您填写的邮箱格式不正确");
        bool = false;
      } else if (!this.subForm.subscribe_product_class_ids.length) {
        this.$message.error("请至少选择一种研究报告类别");
        bool = false;
      } else if (this.subForm.subscribe_activity_class_ids && this.subForm.subscribe_activity_class_ids.length > 0) {
        let arr = [];
        for (let i = 0; i < this.subForm.subscribe_activity_class_ids.length; i++) {
          let item = this.subForm.subscribe_activity_class_ids[i];
          if (item === 99999) {
            const cnOther = this.cnActivityClass .find(e => e.id === 99999);
            if (cnOther.ids && cnOther.ids.length > 0) {
              arr = arr.concat(cnOther.ids);
            }
          } else if (item === 88888) {
            const enOther = this.enActivityClass .find(e => e.id === 88888);
            if (enOther.ids && enOther.ids.length > 0) {
              arr = arr.concat(enOther.ids);
            }
          } else {
            arr.push(item);
          }
        }
        sendForm.subscribe_activity_class_ids = arr.join();
      }
      return bool ? sendForm : bool;
    },
    async saveSubscribe() {
      if (this.subLoading) return;
      const tempForm = this.validateForm();
      if (tempForm) {
        this.subLoading = true;
        let succeeded = false;
        try {
          const res = await emailSubscribe(tempForm);
          if (res && res.code == 200) {
            succeeded = true;
            this.$message.success({
              message: res.msg || "订阅成功！请留意查收欢迎邮件",
              onClose: () => { window.location.href = '/'; }
            });
          }
        } catch (error) { /* 请求层显示失败信息，保留表单供用户重试。 */ }
        finally {
          if (!succeeded) this.subLoading = false;
        }
      }
    },

    async cancelMailSubscribe(e) {
      if (e) {
        this.loading = true;
        let res = await unsubscribe({id: e});
        if (res && res.code == 200) {
          this.$message.success(res && res.msg ? res.msg : '邮件退订成功');
        }
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chinese-push {
  &-wrap {
    font-family: "HarmonyOS_Sans_Regular";
    width: 50%;
    margin: 50px auto 80px auto;
    .check-box {
      position: relative;
      flex: 1;
      cursor: pointer;
      padding: 10px 40px 10px 15px;
      display: flex;
      align-items: center;
      background-color: #FCFAFA;
      border-radius: 8px;
      border: 1px solid #E9E9E9;
      .square {
        position: relative;
        width: 16px;
        height: 16px;
        border: 1px solid #CCCCCC;
        border-radius: 4px;
        .icon-tick {
          font-size: 26px;
          position: absolute;
          left: -9px;
          top: -5px;
          color: #ED6F33;
          opacity: 0;
        }
        &.active {
          .icon-tick {
            opacity: 1;
          }
        }
      }
      .square-title {
        margin-left: 10px;
        font-size: 15px;
        color: #231815;
      }
      &:hover, &:active {
        border-color: #ED6F33;
      }
      &:after {
        content: attr(data-text);
        position: absolute;
        top: 50%;      /* 垂直居中 */
        transform: translateY(-50%);  /* 精确垂直居中 */
        left: calc(100% + 1px);  /* 父元素宽度 + 右边框宽度 */
        white-space: nowrap;    /* 防止文本换行 */
        text-align: left;       /* 文本左对齐 */
        padding-left: 15px;      /* 与边框保持距离 */
        font-size: 12px;
        color: #BBBBBB;
      }
    }
    &-header {
      margin-top: 100px;
      padding-bottom: 50px;
      border-bottom: 1px solid #CCCCCC;
      &-title {
        font-size: 44px;
        color: #1E1E1E;
        font-family: HarmonyOS_Bold;
      }
    }
    &-tip {
      font-size: 14px;
      color: #1E1E1E;
      margin-top: 50px;
      line-height: 30px;
    }
    &-email {
      margin-top: 50px;
      &-title {
        color: #1E1E1E;
        font-family: HarmonyOS_Bold;
        font-size: 24px;
      }
      &-input {
        max-width: 360px;
        margin-top: 15px;
        ::v-deep {
          .el-input__inner {
            border-radius: 8px !important;
            height: 38px;
            line-height: 38px;
            &:focus {
              border-color: #ED6F33;
            }
          }
        }
      }
    }
    &-content {
      margin-top: 80px;
      &-title {
        color: #1E1E1E;
        font-family: HarmonyOS_Bold;
        font-size: 24px;
      }
      &-list {
        margin-top: 20px;
        display: flex;
        &-group {
          &:nth-child(n+2) {
            // margin-left: 20%;
            margin-left: 250px;
          }
          &-title {
            color: #1E1E1E;
            font-size: 14px;
          }
          &-listing {
            display: flex;
            flex-direction: column;
            &-cell {
              margin-top: 20px;
            }
          }
        }
      }
    }
    &-language {
      margin-top: 80px;
      &-title {
        color: #1E1E1E;
        font-family: HarmonyOS_Bold;
        font-size: 24px;
      }
      &-list {
        margin-top: 40px;
        display: flex;
        .check-box {
          max-width: 100px;
          &:last-child {
            margin-left: 30px;
          }
        }
      }
    }
    &-opera {
      margin-top: 80px;
      padding-bottom: 120px;
      ::v-deep {
        .el-button--medium {
          width: 208px;
          cursor: pointer;
          text-align: center;
          color: #ffffff;
          border-radius: 6px;
          background-color: #ED6F33;
          &:hover,&:active {
            background-color: #f68a56;
          }
        }
      }
      &-tip {
        margin-top: 10px;
        font-size: 12px;
        color: #BBBBBB;
        .link {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
}
.english-push {
  &-wrap {
    &-content {
      margin-top: 80px;
      &-title {
        color: #1E1E1E;
        font-family: HarmonyOS_Bold;
        font-size: 24px;
      }
      &-list {
        margin-top: 20px;
        display: flex;
        &-group {
          &:nth-child(n+2) {
            // margin-left: 20%;
            margin-left: 200px;
          }
          &-title {
            color: #1E1E1E;
            font-size: 14px;
          }
          &-listing {
            display: flex;
            flex-direction: column;
            &-cell {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .chinese-push, .english-push {
    &-wrap {
      width: calc(100% - 60px);
      margin: 0 auto;
      &-content {
        &-list {
          justify-content: space-between;
          &-group {
            &:nth-child(n+2) {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .chinese-push {
    &-wrap {
      width: calc(100% - 60px);
      .check-box {
        width: 55%;
        padding: 10px 20px 10px 15px;
        .square-title {
          font-size: 12px;
        }
      }
      &-header {
        margin-top: 50px;
        padding-bottom: 30px;
        &-title {
          font-size: 32px;
        }
      }
      &-tip {
        margin-top: 20px;
        font-size: 12px;
        line-height: 24px;
      }
      &-email {
        &-title {
          font-size: 20px;
        }
      }
      &-content {
        margin-top: 50px;
        &-title {
          font-size: 20px;
        }
        &-list {
          flex-wrap: wrap;
          flex-direction: column;
          &-group {
            margin-bottom: 20px;
            &:nth-child(n+2) {
              margin-left: 0;
            }
          }
        }
      }
      &-language {
        margin-top: 50px;
      }
      &-opera {
        margin-top: 50px;
        ::v-deep {
          .el-button--medium {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
